import Button from 'components/actions/Button';
import Dialog from 'components/overlays/Dialog';

import styles from './styles/DeleteVehicleDialog.module.scss';

interface DeleteVehicleDialogProps {
    show: boolean;
    isLoading: boolean;
    isError: boolean;
    onCancel(): void;
    onConfirm(): void;
}

const DeleteVehicleDialog = ({ show, isLoading, isError, onCancel, onConfirm }: DeleteVehicleDialogProps) => (
    <Dialog
        data-testid='delete-vehicle-dialog'
        className={styles.dialog}
        show={show}
        title='Are you sure you want to delete the vehicle?'
        showCloseButton
        onClose={onCancel}
        body={
            <>
                <p>The vehicle will be deleted and we won&apos;t be able to recover your vehicle.</p>
                {isError && (
                    <p className='text-color-danger mt-10'>The vehicle could not be deleted. Please try again.</p>
                )}
            </>
        }
        footer={
            <div className='display-flex justify-content-end gap-10'>
                <Button variant='outline' style='primary' onClick={onCancel} data-testid='delete-vehicle-cancel'>
                    No, cancel
                </Button>
                <Button style='danger' onClick={onConfirm} isLoading={isLoading} data-testid='delete-vehicle-confirm'>
                    Yes, Delete
                </Button>
            </div>
        }
    />
);

export default DeleteVehicleDialog;
